// frontend/src/services/api.js

import axios from 'axios';

//const API_BASE_URL = 'https://164.160.33.227:5000/api';
//const API_BASE_URL = 'http://localhost:5000/api';
const API_BASE_URL = 'https://control-api.lynk.ci/api';

// ✅ FONCTION SIMPLIFIÉE
function getApiBaseUrl() {
  const apiUrl = process.env.REACT_APP_API_URL;

  if (!apiUrl) {
    console.error('❌ REACT_APP_API_URL non définie dans .env');
    //return 'https://164.160.33.227:5000/api'; // ✅ Fallback vers le VPS
    //return 'http://localhost:5000/api';
    return 'https://control-api.lynk.ci/api';
  }

  console.log('🌐 API URL depuis .env:', apiUrl);
  return apiUrl;
}

//const API_BASE_URL = getApiBaseUrl();
console.log('✅ API configurée sur:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur de requête
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // ✅ Désactiver le cache pour /devices
    if (config.url?.includes('/devices')) {
      config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      config.headers['Pragma'] = 'no-cache';
      config.headers['Expires'] = '0';
      
      if (!config.url.includes('?t=')) {
        config.url += (config.url.includes('?') ? '&' : '?') + `t=${Date.now()}`;
      }
    }
    
    // Timeout étendu pour les commandes
    if (config.url?.includes('/control') || config.url?.includes('/direct-control')) {
      config.timeout = 90000;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur de réponse
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Gestion des erreurs réseau
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
      console.error('🌐 ERREUR RÉSEAU - Backend inaccessible ou timeout');
      console.error('URL tentée:', error.config?.baseURL);
      console.error('Endpoint:', error.config?.url);
      
      const userMessage = error.code === 'ECONNABORTED' 
        ? 'La commande a pris trop de temps. Le device est peut-être hors ligne. Veuillez réessayer.'
        : 'Impossible de contacter le serveur. Vérifiez votre connexion internet.';
      
      return Promise.reject(new Error(userMessage));
    }
    
    // Session expirée (401)
    if (error.response?.status === 401) {
      const isExpired = error.response?.data?.expired;
      
      if (isExpired) {
        console.log('⏰ Session expirée (inactivité > 3 min)');
        alert('Votre session a expiré après 3 minutes d\'inactivité. Veuillez vous reconnecter.');
      } else {
        console.log('⚠️ Session invalide');
      }
      
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('sessionExpires');
      
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    
    // Session déjà active (403)
    if (error.response?.status === 403) {
      console.log('⚠️ Session déjà active sur un autre appareil');
    }
    
    return Promise.reject(error);
  }
);

export default api;